import axios from 'axios';
//FLF Dev Server is https://172.16.0.26



//export default api; --use this instead when testing locally
//export default axios; --use this when deploying
let api = axios;
// if(process.env.NODE_ENV!=='production'){
//     api = axios.create({
//         baseURL: 'https://104.168.164.112',
//         //baseURL: 'http://localhost:44376', //when running local for both front and back-end
//     });
//     api.CancelToken = axios.CancelToken;
//     api.isCancel = axios.isCancel;
// }
export default api;
